import { render, staticRenderFns } from "./officeInputTaxConfig.vue?vue&type=template&id=e8aa6cbc&"
import script from "./officeInputTaxConfig.vue?vue&type=script&lang=js&"
export * from "./officeInputTaxConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8aa6cbc')) {
      api.createRecord('e8aa6cbc', component.options)
    } else {
      api.reload('e8aa6cbc', component.options)
    }
    module.hot.accept("./officeInputTaxConfig.vue?vue&type=template&id=e8aa6cbc&", function () {
      api.rerender('e8aa6cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/role/officeInputTaxConfig.vue"
export default component.exports